export default __webpack_public_path__ + "static/media/niraj_kharel.7956309b.jpg";